export default {
  setFullScreenLoading(state, fullScreenLoading) {
    state.fullScreenLoading = fullScreenLoading;
  },
  setUser(state, user) {
    state.user = {
      ...state.user,
      ...user
    };
  },
  updateUser(state, data) {
    for (const i in data) {
      state.user[i] = data[i];
    }
  },
  setLogged(state, logged) {
    state.logged = logged;
  },
  reset(state) {
    state.user = null;
    state.logged = false;
  },
  setCoProducers(state, coproducers) {
    state.coproducers = coproducers;
  },
  setCoProducerOders(state, coproducerOrders) {
    state.coproducerOrders = coproducerOrders;
  },
  setMyCoproducers(state, myCoproducers) {
    state.myCoproducers = myCoproducers;
  },
  setCount(state, count) {
    state.count = count;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setAccountInfo(state, accountInfo) {
    state.accountInfo = accountInfo;
  },
  setPreferences(state, preferences) {
    state.preferences = preferences;
  },
  setSurvey(state, survey) {
    state.survey = survey;
  }
};
